import useVisible from "../../hooks/useVisible.jsx";
import handleClick from "../../utils/handleClick.js";

function SplitTextLayer({ selectedTag, buttonTags, generateButtonTags }) {
  const [isVisible, setIsVisible] = useVisible("SplitTextLayerVisibility");
  const [animation, setAnimation] = useVisible("animationTextLayer");
  const [splitType, setSplitType] = useVisible("SplitTextLayerType");

  if (selectedTag && !buttonTags.includes(selectedTag)) {
    return null;
  }

  return (
    <>
      <li
        onClick={() => setIsVisible(!isVisible)}
        className={`button-card resolution-toggle ${isVisible ? "active" : ""}`}
      >
        <div className="button-card__icon">
          <i class="fa-solid fa-scissors"></i>
        </div>
        <div className="button-card__title">Split Text</div>
        {generateButtonTags()}
      </li>
      <div
        className={`render-group ${isVisible ? "" : "render-group--hidden"}`}
      >
        <div className="render-group__checkbox-group">
          <div className="render-group__checkbox">
            <input
              type="checkbox"
              id="animation-text-layer"
              checked={animation}
              onChange={() => setAnimation(!animation)}
              className="hidden-checkbox"
            />
            <label htmlFor="animation-text-layer">
              <span className="custom-checkbox"></span>
              <span className="label-text">Animation</span>
            </label>
          </div>
        </div>
        <div className="render-group__checkbox-group">
          <div className="render-group__dropdown">
            <span className="render-group__dropdown-text">Split Type</span>
            <select
              id="type"
              name="type"
              onChange={(event) => setSplitType(event.target.value)}
              value={splitType}
            >
              <option value={"letter"}>Letters</option>
              <option value={"word"}>Words</option>
              <option value={"lines"}>Lines</option>
            </select>
          </div>
        </div>

        <div className="render-group__tools-grid">
          <div
            onClick={() =>
              handleClick("splitText", {
                type: "layer",
                splitType: splitType,
                animation: animation,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-light fa-layer-group"></i>
            <span>Selected Layers</span>
          </div>
          <div
            onClick={() =>
              handleClick("splitText", {
                type: "comp",
                splitType: splitType,
                animation: animation,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-image-polaroid"></i>
            <span>Active Comp</span>
          </div>
          <div
            onClick={() =>
              handleClick("splitText", {
                type: "selected comp",
                splitType: splitType,
                animation: animation,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-solid fa-images"></i>
            <span>Selected Comp</span>
          </div>
          <div
            onClick={() =>
              handleClick("splitText", {
                type: "project",
                splitType: splitType,
                animation: animation,
              })
            }
            className="resolution-tools__button"
          >
            <i class="fa-regular fa-photo-film"></i>
            <span>Project</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default SplitTextLayer;
